import { Navigate } from 'react-router-dom';

import { useSalesFeatures } from '@/hooks/useSalesFeatures';

/**
 * The default `/app` landing route. Sales-mode users keep the pipeline (grading)
 * front door; personal-CRM users land on Stay in Touch. Returns null while
 * settings load to avoid a redirect flash.
 */
export function DefaultAppRedirect() {
  const salesFeatures = useSalesFeatures();
  if (salesFeatures === undefined) return null;
  return <Navigate to={salesFeatures ? '/app/pipeline' : '/app/keep-in-touch'} replace />;
}
